import { BaseEnum } from './BaseEnum';

export const SiteAlertSeverity = {
    None: 0,
    Severe: 1,
    Medium: 2,
    Low: 3,

    ...BaseEnum,
};
